import { styled } from '@mui/material/styles';

import MuiButton from '@mui/material/Link';

export const Button = styled(MuiButton)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  gap: theme.spacing(1)
}));
